import React from "react";

import * as S from "./styles";

export const Slide13: React.FC = () => {
  return (
    <S.Container>
      <S.Text>
        Mickael veste túnica Haight, R$ 798, e corrente, Skull, R$ 420. Suyane
        veste capa, Teodora Oshima, R$ 1.621, brinco, Struktura, R$ 1.150 (o
        par), e anel, Brennheisen, R$ 1.900.
      </S.Text>
      <S.Photo />
    </S.Container>
  );
};
